import axios from 'axios';

let prefix = "/stakeholder"

const StakeholderApi = {

	getStakeholderList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	createStakeholder(payload){
		return axios.post( prefix + "/create", payload)
	},
	updateStakeholder(payload){
		return axios.post( prefix + "/update", payload)
	},
	updateStakeholderPassword(payload){
		return axios.post( prefix + "/password/update", payload)
	},
	archiveStakeholder(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
	restoreStakeholder(payload){
		return axios.post( prefix + "/restore", payload)
	},
	getStakeholderLocations(id, payload){
		return axios.get( prefix + "/locations/"+id, {params: payload})
	},
	updateStakeholderLocations(payload){
		return axios.post( prefix + "/locations/update", payload)
	},
	getStakeholderEvses(id, payload){
		return axios.get( prefix + "/evses/"+id, {params: payload})
	},
	updateStakeholderEvses(payload){
		return axios.post( prefix + "/evses/update", payload)
	},
}

export default StakeholderApi;
